import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@fmt/constants'
import { CareProfessionalKeys, CareProfessionalValues } from '@fmt/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    careprofessionalEditFormik: FormikProps<CareProfessionalValues>
    handleKeyDown: (
        e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>,
        fieldName?: CareProfessionalKeys
    ) => void
}

const Profession = ({ readOnly, careprofessionalEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: CareProfessionalKeys = 'careProfessionalProfession'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.CAREPROFESSIONAL.EDIT.PROFESSION} className={'form-label'}>{
                    strings.fmt?.text.department.details.table.profession
                }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        careprofessionalEditFormik.errors
                            .careProfessionalProfession && 'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly
                        ? strings.fmt?.text
                            .department.details.table.profession
                        : ''}
                    value={careprofessionalEditFormik.values.careProfessionalProfession}
                    id={IDS.CAREPROFESSIONAL.EDIT.PROFESSION}
                    onBlur={careprofessionalEditFormik.handleBlur}
                    onChange={!readOnly ? careprofessionalEditFormik.handleChange : () => {}}
                    onKeyDown={(e) => handleKeyDown(e, 'careProfessionalLocation')}
                    required
                />
                <div className={'form-text error'}>{
                    careprofessionalEditFormik.errors.careProfessionalProfession
                        ? careprofessionalEditFormik.errors.careProfessionalProfession
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default Profession
